import { useUser } from '@lore/auth';
import { useQueryMutation } from '@lore/query-connect';
import React from 'react';
import EditableString from '@/components/ui/EditableString';
import AvatarUpload from '@/components/filestack/AvatarUpload';
import EditableExperiences from './EditableExperiences';
import useDialogLauncher from '@/dialogs-routable/_hooks/useDialogLauncher';
import { DialogManager } from '@/dialogs_new/DialogManager';
import useEditableField from '@/hooks/useEditableField';

export default function AboutYouSection() {
  const currentUser = useUser();
  const { firstName, lastName, biography, website, linkedinUrl } = currentUser.data;

  const userMutation = useQueryMutation('currentUser.updateSingleton', currentUser);
  const launch = useDialogLauncher();

  const save = (field) => (value) => userMutation.mutateAsync({ [field]: value });

  const firstNameField  = useEditableField(firstName,   save('firstName'));
  const lastNameField   = useEditableField(lastName,    save('lastName'));
  const biographyField  = useEditableField(biography,   save('biography'));
  const websiteField    = useEditableField(website,     save('website'));
  const linkedinField   = useEditableField(linkedinUrl, save('linkedinUrl'));

  return (
    <section id="about" className="py-8">
      <h2 className="mb-8 text-2xl font-semibold text-cs-gray-900">About you</h2>
      {/*<pre>{JSON.stringify(_.pick(currentUser.data, ['firstName', 'lastName']))}</pre>*/}

      <div className="grid gap-10 lg:grid-cols-[280px_1fr]">
        <AvatarUpload />

        <div className="space-y-12">
          <div className="grid gap-8 md:grid-cols-2">
            <EditableString
              label="First name"
              {...firstNameField}
              editAriaLabel="Edit first name"
            />

            <EditableString
              label="Last name"
              {...lastNameField}
              editAriaLabel="Edit last name"
            />
          </div>

          <EditableString
            label={(
              <span>
                In 1-2 sentences how would you describe yourself?{' '}
                <button
                  type="button"
                  className="text-base font-normal text-cs-orange-500 hover:underline"
                  onClick={() => launch(DialogManager.BiographySuggestions.Config())}
                >
                  Need an example?
                </button>
              </span>
            )}
            {...biographyField}
            editAriaLabel="Edit biography"
            fieldType="textarea"
          />

          <div className="grid gap-8 md:grid-cols-2">
            <EditableString
              label="Website"
              {...websiteField}
              editAriaLabel="Edit website"
            />

            <EditableString
              label="LinkedIn"
              {...linkedinField}
              editAriaLabel="Edit LinkedIn"
            />
          </div>

          <EditableExperiences />
        </div>
      </div>
    </section>
  );
}
